<template>
  <div><product-table /></div>
</template>

<script>
import { mapState } from 'vuex'
import ProductTable from '../components/product/Table.vue'

export default {
  components: {
    ProductTable
  },
  computed: {
    ...mapState(['contracts'])
  },
  methods: {},
  async mounted() {}
}
</script>
<style>
* {
}
</style>
